/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type RapidBoardEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const rapidBoardEntryPoint: EntryPoint<RapidBoardEntryPointComponent, {}> = createEntryPoint(
	{
		root: JSResourceForUserVisible<RapidBoardEntryPointComponent>(
			/* webpackChunkName: "async-rapid-board-entrypoint" */ './RapidBoardWrapper.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => {
			return {};
		},
	},
);
